module.exports = __webpack_public_path__ + "static/media/local_grocery_store_black_24dp.3cc0e7ae.svg";